import { Navigate, RouteObject } from 'react-router-dom';
import { PrivateRoute } from 'App/routes';
import {
  FoodSettingsPage,
  HomePage,
  LandingPage,
  LoadingPage,
  LogoutPage,
  ProfileSettingsPage,
  ReportDetailsPage,
  SSOPage,
  TransactionDetailsEditPage,
  TransactionDetailsPage,
} from 'impactApp/modules';

import { RoutePaths } from 'impactApp/routes/routePaths';

export const ROUTES: RouteObject[] = [
  { path: RoutePaths.HOME, element: <PrivateRoute element={<HomePage />} /> },
  { path: RoutePaths.REPORT_DETAILS, element: <PrivateRoute element={<ReportDetailsPage />} /> },
  { path: RoutePaths.TRANSACTION_DETAILS, element: <PrivateRoute element={<TransactionDetailsPage />} /> },
  { path: RoutePaths.TRANSACTION_DETAILS_EDIT, element: <PrivateRoute element={<TransactionDetailsEditPage />} /> },
  { path: RoutePaths.PROFILE_SETTINGS, element: <PrivateRoute element={<ProfileSettingsPage />} /> },
  { path: RoutePaths.FOOD_SETTINGS, element: <PrivateRoute element={<FoodSettingsPage />} /> },
  { path: RoutePaths.LOGOUT_PAGE, element: <LogoutPage /> },
  { path: RoutePaths.SSO_PAGE, element: <SSOPage /> },
  { path: RoutePaths.LOADING_PAGE, element: <PrivateRoute element={<LoadingPage />} /> },
  { path: RoutePaths.LANDING_PAGE, element: <PrivateRoute element={<LandingPage />} /> },

  { path: '*', element: <Navigate to={RoutePaths.HOME} /> },
];
